module.exports = __webpack_public_path__ + "static/media/bright_logo.57adbda4.svg";